<template>
    <div class="container my-5 py-4">
      <div class="container">
        <div class="row gx-3">
          <div class="col-12">
            <h2>Vragen over deze auto?</h2>
            <p>Wij helpen je graag verder</p>
            <div class="row crc-reffer-cards mt-4 px-0">
              <VueSlickCarousel ref="carousel" :infinite="false" prev-arrow="<button class='slickarrow slick-prev'><svg width='16px' height='14px'><use xlink:href='#Icon--chevron-down'></use></svg></button" next-arrow="<button class='slickarrow slick-next'><svg width='16px' height='14px'><use xlink:href='#Icon--chevron-down'></use></svg></button" :autoplay-speed="4000" :slides-to-show="4"  :responsive="[{breakpoint: 1200, settings: {slidesToShow: 3}}, {breakpoint: 992, settings: {slidesToShow: 2}}, {breakpoint: 600, settings: {slidesToShow: 1}}]">
                <div class="col-sm-6 col-lg-3 mt-4 mt-sm-0">
                  <div class="crc-reffer-card-img-head">
                    <div class="crc-img-container">
                      <img :src="locations && locations[car.location] && car.location !== undefined ? locations[car.location].photo : contact.photo">
                    </div>
                  </div>
                  <div class="p-5 crc-reffer-card-body">
                    <h3>{{ locations && locations[car.location] && car.location !== undefined ? locations[car.location].title : contact.name}}</h3>
                    <p>{{ locations && locations[car.location]  && car.location !== undefined ? locations[car.location].address : contact.address}}</p>
                    <a class="btn inline mail" :href="'mailto:' + (locations && locations[car.location] && car.location !== undefined  ? locations[car.location].email : contact.email)">{{ locations && locations[car.location]  && car.location !== undefined ? locations[car.location].email : contact.email }}</a>
                    <a class="btn inline tel" :href="'tel:' + (locations && locations[car.location] && car.location !== undefined  ? locations[car.location].phone : contact.phone)">{{ locations && locations[car.location]  && car.location !== undefined ? locations[car.location].phone : contact.phone }}</a>
                    <a class="btn inline map" :href="'https://www.google.com/maps/dir//' +( locations && locations[car.location] && car.location !== undefined  ? locations[car.location].address : contact.address)" target="_blank">Route plannen</a>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-3 mt-4 mt-sm-0" v-for="employee in employees" v-bind:key="employee.id">
                  <div class="crc-reffer-card-img-head" v-if="employee.media.length > 0">
                    <div class="crc-img-container header">
                      <img :src="employee.media[0].original_url">
                    </div>
                    <div class="crc-img-container person crc-shadow">
                      <img :src="employee.media[0].original_url">
                    </div>
                  </div>
                  <div class="crc-reffer-card-img-head" v-if="employee.media.length === 0">
                    <div class="crc-img-container header">
                      <img src="../../assets/placeholder.jpg">
                    </div>
                    <div class="crc-img-container person crc-shadow">
                      <img src="../../assets/placeholder.jpg">
                    </div>
                  </div>
                  <div class="p-5 crc-reffer-card-body">
                    <h3>{{ employee.name }}</h3>
                    <p>{{ employee.description }}</p>
                    <a v-if="employee.email" class="btn inline mail" :href="'mailto:' + employee.email">{{ employee.email }}</a>
                    <a  v-if="employee.phone" class="btn inline tel" :href="'tel:+' + employee.phone">{{ employee.phone }}</a>
                  </div>
                </div>
              </VueSlickCarousel>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>
<script setup>
  import { ref } from "vue";
  import { VueSlickCarousel } from "vue-slick-ts";
  import { SlickInstance } from "vue-slick-ts";
  import "vue-slick-ts/dist/css/slick.css";

  const carousel = ref<SlickInstance | null>(null);
</script>
<script>
export default {
  props: ['car', 'cars', 'contact', 'employees','locations'],
}
</script>
<style lang="scss" scoped>
.crc-car-component-container {
  .crc-single-car-hero .col-inner {
    border-radius: 4px;
    background-color: white;
  }

  .crc-imgslider {
    .crc-img-container {
      height: 700px;
    }
  }

  .crc-imgslider-nav {
    .crc-img-container {
      height: 100px;
      width: 14%;
    }
  }

  .crc-buttons {
    margin: 0 -6px;
    display: flex;
    flex-wrap: wrap;

    .btn {
      width: calc(100% - 12px);
      margin: 6px;

      &.half {
        width: calc(50% - 12px);
      }
    }
  }

  .crc-side-imgbg {
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 35%, rgba(0,0,0,.7) 100%);
    background-color: lightgrey;
    border-radius: 4px;
  }

  .crc-reffer-cards {
    .crc-reffer-card-img-head {
      position: relative;

      .crc-img-container {
        height: 200px;

        &.person {
          position: absolute;
          bottom: -20px;
          left: 48px;
          width: 100px;
          height: 100px;
          border-radius: 100px;
        }
      }
    }

    .crc-reffer-card-body {
      background-color: white;

      a.btn {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.crc-reffer-cards {
  .slick-track {
    display: flex;
    justify-content: stretch;
    margin-left: 0;

    @media (max-width: 479px) {
      align-items: start;
    }
  }

  .slick-slide {
    background-color: white;
    margin: 5px;
    height: auto;
  }

  button.slick-arrow {
    appearance: none;
    -webkit-appearance: none;
    border: none;
    padding: 10px;
    background: black;
    border-radius: 50px;
    box-shadow: none;
    position: absolute;
    width: 38px;
    height: 38px;
    top: calc(50% - 15px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    padding-top: 13px;
    border: 1px solid white;

    &::before,
    &::after {
      display: none !important;
    }

    &.slick-prev {
      left: 0;
      transform: rotate(90deg);
    }

    &.slick-next {
      right: 0;
      transform: rotate(-90deg);
    }

    svg {
      fill: white;
    }
  }

  @media (max-width: 1770px) and (min-width: 1400px) {
    padding-left: 3em !important;
    padding-right: 3em !important;
  }
}
</style>
